module.exports = __webpack_public_path__ + "img/logo.63c8e0b9.jpg";